import { render, staticRenderFns } from "./ModalReprovacao.vue?vue&type=template&id=60a17e82&"
import script from "./ModalReprovacao.vue?vue&type=script&lang=js&"
export * from "./ModalReprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports